import { render, staticRenderFns } from "./Solo.vue?vue&type=template&id=26dbb12e&scoped=true"
import script from "./Solo.vue?vue&type=script&lang=js"
export * from "./Solo.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=26dbb12e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dbb12e",
  null
  
)

export default component.exports